// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"7bf831d3","675":"7bf831d3","746":"7bf831d3"}[chunkId] + ".chunk.css";
};